import { Offcanvas, Table } from "react-bootstrap";

const UpdatedActivity = ({ Show, Hide, itemData, isDark }) => {
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" style={{width: 800}}>
      <Offcanvas.Header
        closeButton
        className={`${isDark ? "bg-dark" : "bg-light"} p-3 border-bottom`}
      >
        <Offcanvas.Title
          className="fw-bold hstack gap-2"
          style={{ fontSize: 15 }}
        >
          <img
            src={itemData?.categoryIcon}
            alt={itemData?.categoryName}
            style={{
              width: 25,
              height: 25,
              objectFit: "contain",
            }}
          />
          <span>{itemData?.categoryName} Updated Activity</span>
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="p-0">
        <Table hover className="m-0" style={{verticalAlign: "middle"}}>
          <thead className="position-sticky top-0">
            <tr className="text-nowrap">
              <th className="CP" style={{fontSize: 13, width: "30%"}}>Activity</th>
              <th className="CP" style={{fontSize: 13}}>Current Value</th>
              <th className="CP" style={{fontSize: 13}}>Previous Value</th>
              <th className="CP" style={{fontSize: 13}}>Activity By</th>
              <th className="CP" style={{fontSize: 13}}>Activity Date | Time</th>
            </tr>
          </thead>
          <tbody>
            <tr title="Activity By: roop80509@gmail.com">
              <td className="item-secondary">(Add) : Lorem Ipsum is simply dummy text of the printing and typesetting industry.</td>
              <td className="item-secondary CP">A/C No.</td>
              <td className="item-secondary CP">-</td>
              <td className="item-secondary">Roop Chandra</td>
              <td className="item-secondary">31 Dec 2025 | 11:59</td>
            </tr>
            <tr title="Activity By : skgautam@gmail.com">
              <td className="item-secondary">(Update) : Lorem Ipsum is simply dummy text of the printing and typesetting industry.</td>
              <td className="item-secondary CP">Account Number</td>
              <td className="item-secondary CP">A/C No.</td>
              <td className="item-secondary">Satish Kumar Gautam</td>
              <td className="item-secondary">31 Dec 2025 | 11:59</td>
            </tr>
          </tbody>
        </Table>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default UpdatedActivity;
